export default __webpack_public_path__ + "static/4_21-ef3a78677b64b4c240eee3bab27a1f9a.png";